import Vue from "vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import vuetify from "./vuetify";

const ConfirmDialogPlugin = {
  install(Vue) {
    const ConfirmConstructor = Vue.extend(ConfirmDialog);
    let instance = null;

    function getInstance() {
      if (!instance) {
        instance = new ConfirmConstructor({ vuetify });
        const el = document.createElement("div");
        document.body.appendChild(el);
        instance.$mount(el);
      }
      return instance;
    }

    /**
     * Usage:
     *   const ok = await this.$confirm({ title: "Delete?", message: "Are you sure?" });
     *   // or shorthand:
     *   const ok = await this.$confirm("Are you sure?");
     */
    Vue.prototype.$confirm = function (options) {
      if (typeof options === "string") {
        options = { message: options };
      }
      return getInstance().open(options);
    };
  },
};

Vue.use(ConfirmDialogPlugin);

export default ConfirmDialogPlugin;
